import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
  normalizePaged,
  type Paged,
} from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import {
  outboxEndpoints,
  type OutboxService,
} from "@/features/outbox/api/endpoints";
import type { OutboxEventDto } from "@/features/outbox/api/dto";

interface Params {
  page?: number;
  pageSize?: number;
}

/**
 * Liste paginée des événements de la boîte d'envoi d'un service
 * (`GET /gw/<service>/api/v1/OutboxEvents/all?page=&pageSize=`, guide v2.5).
 */
export const useOutboxEvents = (service: OutboxService, params: Params = {}) => {
  const page = params.page ?? DEFAULT_PAGE;
  const pageSize = params.pageSize ?? DEFAULT_PAGE_SIZE;
  return useQuery({
    queryKey: QUERY_KEYS.OUTBOX_EVENTS_LIST(service, { page, pageSize }),
    queryFn: async () => {
      const data = await fetchDataGet<Paged<OutboxEventDto> | OutboxEventDto[]>({
        url: outboxEndpoints.all(service),
        queryParams: {
          page: String(page),
          pageSize: String(pageSize),
        },
      });
      return normalizePaged(data, pageSize);
    },
  });
};
